import { useState } from "react";

import { mnpNavigation } from "app/pages/digital-marketing/monitor-and-protect/app/navigation";
import { useMonitorAndProtectCampaigns } from "app/pages/digital-marketing/monitor-and-protect/services/api/campaign";
import { CreateCampaignWizard } from "app/pages/digital-marketing/monitor-and-protect/shared/components/create-campaign-wizard";
import { SegmentsPageLoader } from "app/pages/segments/segmentsPageLoader";

import { DemoLink } from "./components/demo-link";
import { HomepageHeader } from "./components/homepage-header";
import { NoCampaignsView } from "./components/no-campaigns-view";
import { WithCampaignsView } from "./components/with-campaigns-view";

export const Homepage = () => {
    const [selectedDomain, setSelectedDomain] = useState<string>("");
    const [isWizardOpen, setIsWizardOpen] = useState<boolean>(false);

    const { data = [], isLoading } = useMonitorAndProtectCampaigns();

    const hasOnlyDemoCampaigns = data.every((campaign) => campaign.type === "Demo");
    const demoId = data.find((campaign) => campaign.type === "Demo")?.id;

    const handleDomainSelect = (domain: string) => {
        setSelectedDomain(domain);
    };

    const handleGetStarted = () => {
        setIsWizardOpen(true);
    };

    const handleCloseWizard = () => {
        setIsWizardOpen(false);
    };

    return (
        <>
            <CreateCampaignWizard
                key={selectedDomain}
                isOpen={isWizardOpen}
                selectedDomain={selectedDomain}
                onClose={handleCloseWizard}
                onCampaignCreated={async ({ id }) => {
                    await mnpNavigation.overview.go({ campaignId: id, ref: "wizard" });
                }}
            />

            <HomepageHeader
                selectedDomain={selectedDomain}
                onDomainSelect={handleDomainSelect}
                onGetStarted={handleGetStarted}
            />

            {isLoading ? (
                <SegmentsPageLoader />
            ) : hasOnlyDemoCampaigns ? (
                <NoCampaignsView />
            ) : (
                <WithCampaignsView campaigns={data.filter((campaign) => campaign.type !== "Demo") || []} />
            )}
            {demoId ? <DemoLink campaignId={demoId} /> : null}
        </>
    );
};
